import React from "react";
import styles from "./ErrorPage.module.css";
import Footer from "../GenericComponents/Footer";

const ErrorPage = ({ errorMessage = "Something went wrong!" }) => {
  const handleClose = () => {
    window.close();
  };

  return (
    <div className="app-page-layout">
      <div className={styles.page}>
        <div className={styles.card}>
          <h1 className={styles.title}>Invitation Link Expired</h1>

          <div className={styles.iconWrapper}>
            <img
              src="/images/invitation-expired.png"
              alt="Expired link"
              className={styles.icon}
            />
          </div>

          <p className={styles.message}>{errorMessage}</p>

          <p className={styles.subMessage}>
            Please request a new invitation to access <strong>Inspyre</strong>,
            powered by Acuma Health User Portal.
          </p>

          <button onClick={handleClose} className={styles.primaryButton}>
            Close this window
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ErrorPage;
